import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiChevronDown, mdiChevronUp, mdiReceiptText } from "@mdi/js";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const PurchaseOrdersMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, openSubmenu, user }) => {
    const { t } = useTranslation();
    const canViewPurchaseOrders = user.roles_names.includes(
      "Purchase Order - View",
    );

    if (!canViewPurchaseOrders) {
      return null;
    }

    return (
      <>
        <ListItemButton
          onClick={() => handleClick("purchaseOrders")}
          title={t("menu.purchaseOrders.title")}
        >
          <ListItemIcon sx={{ minWidth: "2rem" }}>
            <Icon icon={mdiReceiptText} />
          </ListItemIcon>
          {!!leftMenuOpen && (
            <ListItemText
              primary={t("menu.purchaseOrders.title")}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: 14,
                  },
                },
              }}
              sx={{ whiteSpace: "normal" }}
            />
          )}
          <Icon
            icon={openSubmenu.purchaseOrders ? mdiChevronUp : mdiChevronDown}
          />
        </ListItemButton>
        <Collapse in={openSubmenu.purchaseOrders} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <HybridRouteListItemButtonLink
              caption="service purchase orders"
              name="purchaseOrders[services]"
              sx={{ pl: 4 }}
              title={t("menu.purchaseOrders.submenu.services")}
              url="/purchase_orders/service_quotations"
            >
              <ListItemText
                primary={t("menu.purchaseOrders.submenu.services")}
                slotProps={{
                  primary: { sx: { fontSize: 14 } },
                }}
                sx={{ whiteSpace: "normal" }}
              />
            </HybridRouteListItemButtonLink>
            <HybridRouteListItemButtonLink
              caption="material purchase orders"
              name="purchaseOrders[materials]"
              sx={{ pl: 4 }}
              title={t("menu.purchaseOrders.submenu.materials")}
              url="/purchase_orders/materials"
            >
              <ListItemText
                primary={t("menu.purchaseOrders.submenu.materials")}
                slotProps={{
                  primary: { sx: { fontSize: 14 } },
                }}
                sx={{ whiteSpace: "normal" }}
              />
            </HybridRouteListItemButtonLink>
          </List>
        </Collapse>
      </>
    );
  },
);
